import { environment } from "./env";
import { CallLogs, Company, EmployeeReport, Employes, Groups, Leads, Leads2, Profile, Roles, User, LeadsForUsers, LeadsHistory, GetCallLogs, GetLeadsCount, LeadsGroups, GetAllDashboardLeadsURL, TeamLeadMappingURL, Mispunch, Attendence, AttendenceURL, notification } from "./Url";
import axios from './CustomAxios'


export const AddRoleAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Roles.AddRole}`
        const response = await axios.post(url, data)
        return response
    } catch (error) {
        console.log('error========', error)
        return error.response?.data
    }
}


export const AddCompanyAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Company.AddCompany}`;
        const response = await axios.post(url, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response;
    } catch (error) {
        console.log('error========', error);
        return error?.response?.data;
    }
};


export const GetAllCompanyAPI = async (parentCompany) => {
    try {
        const url = `${environment.base_url}${Company.getCompany}parentCompany=${parentCompany != undefined ? parentCompany : ""}&companyName=&page=1&limit=500`
        const response = await axios.get(url)
        return response?.data
    } catch (err) {
        console.log('Error:', err)
    }
}

export const GetAllCompanyPaginationAPI = async (data) => {
    const { p = "", records = "", parentCompany = "" } = data
    try {
        const url = `${environment.base_url}${Company.getCompany}parentCompany=${parentCompany != undefined ? parentCompany : ""}&companyName=&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data
    } catch (err) {
        console.log('Error:', err)
    }
}


export const GetAllRolesAPI = async (companyId) => {
    try {
        const url = `${environment.base_url}${Roles.RolesPagination}companyId=${companyId != undefined ? companyId : ""}&page=1&limit=500`
        const response = await axios.get(url)
        return response?.data
    } catch (err) {
        console.log('Error:', err)
    }
}


export const RolesPaginationAPI = async (data) => {
    const { companyId = "", p = data?.p, records = data?.records } = data
    try {
        const url = `${environment.base_url}${Roles.RolesPagination}companyId=${companyId != undefined ? companyId : ""}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data;
    } catch (error) {
        console.log('error========', error)
    }
}

export const RolesPaginationReduxAPI = async (data) => {
    const { companyId = "", p = data?.p, records = data?.records } = data
    try {
        const url = `${environment.base_url}${Roles.RolesPagination}companyId=${companyId != undefined ? companyId : ""}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response;
    } catch (error) {
        console.log('error========', error)
    }
}


export const RegisterUserAPI = async (data) => {
    try {
        const url = `${environment.base_url}${User.RegisterUser}`
        const response = await axios.post(url, data)
        return response;
    } catch (error) {
        console.log('error========', error)
        return error?.response?.data
    }
}


export const LoginUserAPI = async (data) => {
    try {
        const url = `${environment.base_url}${User.LoginUser}`
        const response = await axios.post(url, data)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}

export const DeleteCompanyAPI = async (id) => {
    try {
        const url = `${environment.base_url}${Company.deleteCompany}${id}`
        const response = await axios.post(url);
        return response
    } catch (err) {
        console.log('Error:', err);
        return err?.response;
    }
}


export const UpdateRoleAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Roles.EditRole}${id}`
        const reponse = await axios.put(url, data)
        return reponse
    } catch (error) {
        console.log('error========', error)
    }
}

export const UpdateComapnyAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Company.EditCompany}${id}`
        const response = await axios.put(url, data);
        return response
    } catch (error) {
        console.log('error-->', error);
        return error?.response?.data;
    }
}

export const DeleteRoleApi = async (id) => {
    try {
        const url = `${environment.base_url}${Roles?.DeleteRole}${id}`
        const response = await axios.post(url, id)
        return response
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}


export const GetAllAdminUserAPI = async (data) => {
    const { id = "", p = "", records = "" } = data;
    try {
        const url = `${environment.base_url}${User.GetAllAdminUser}${id}?search=&company=&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data
    } catch (err) {
        console.log('Error:', err)
    }
}

export const UpdateAdminUserAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${User.UpdateAdminUser}${id}`
        const reponse = await axios.post(url, data)
        return reponse
    } catch (error) {
        console.log('error========', error)
        return error?.response?.data
    }
}


export const DeleteAdminUserApi = async (id) => {
    try {
        const url = `${environment.base_url}${User?.DeleteUser}${id}`
        const response = await axios.post(url, id)
        return response
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}

export const DeleteUserAPI = async (id) => {
    try {
        const url = `${environment.base_url}${User.DeleteUser.replace(':id', id)}`
        const response = await axios.post(url)
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const AssignUserAPI = async (data) => {
    const { company = "", search = "",role="", roleId = "",user="", id = "", p = "", records = "" } = data;
    try {
        const url = `${environment.base_url}${Employes.AssignUsers}id=${id}&search=${search != undefined ? search : ''}&company=${company != undefined ? company : ""}&role=${role}&roleId=${roleId}&user=${user}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data
    } catch (error) {
        console.log('Error:', error)
    }
}
export const StaticUserAPI = async (data) => {
    const { company = "", search = "", role = "", id = "", p = "", records = "" } = data;
    try {
        const url = `${environment.base_url}${Employes.AssignUsers}id=${id}&role=${role}&search=${search != undefined ? search : ''}&company=${company != undefined ? company : ""}&roleId=&page=${p}&limit=1000`
        const response = await axios.get(url)
        return response?.data
    } catch (error) {
        console.log('Error:', error)
    }
}

export const EmployeeReportAPI = async (data) => {
    try {
        const url = `${environment.base_url}${EmployeeReport.EmployeeReport}userId=${encodeURIComponent(data?.id)}&startDate=${data?.startDate}&endDate=${data?.endDate}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.log('error', error)
    }
}



export const AddLeadsAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Leads.AddLeads}`
        const response = await axios.post(url, data)
        return response
    } catch (error) {
        console.log('error========', error)
        return error?.response?.data
    }
}


export const UploadCSVAPI = async (formData) => {
    try {
        const url = `${environment.base_url}${Leads.UploadCSV}`
        const response = await axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Specify the correct content type
            },
        });
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const UploadCSVLeadStatusAPI = async (formData) => {
    try {
        const url = `${environment.base_url}${Leads.bulkLeadUploadwStatus}`
        const response = await axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Specify the correct content type
            },
        });
        return response
    } catch (error) {
        console.log('error', error)
    }
}

export const GetAllLeadsAPI = async (data) => {
    const { id = "", search = "", role = "", companyId = "", leadStatus = "",phoneNumber="",startDate="",endDate="", p = "", records = "" } = data
    try {
        const url = `${environment.base_url}${Leads.getleads}id=${id}&role=${role}&companyId=${companyId}&search=${search != undefined ? search : ""}&leadStatus=${leadStatus}&phoneNumber=${phoneNumber}&startDate=${startDate}&endDate=${endDate}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data
    } catch (err) {
        console.log('Error:', err)
    }
}

export const GetallLeads2API = async (data) => {
    const { company = "", search = "", leadStatus = "",phoneNumber="", user = "", role = "", id = "", p = data?.p, records = data?.records } = data;
    try {
        const url = `${environment.base_url}${Leads2.getallLeads}id=${id != undefined ? id : ""}&role=${role != undefined ? role : ""}&search=${search != undefined ? search : ""}&company=${company != undefined ? company : ""}&leadStatus=${leadStatus != undefined ? leadStatus : ""}&user=${user != undefined ? user : ""}&phoneNumber=${phoneNumber}&page=${p}&limit=${records}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (err) {
        console.log('Error:', err)
    }
}


export const UpdateLeadsAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Leads.UpdateLeads}${id}`;
        const response = await axios.put(url, data);
        return response;
    } catch (error) {
        console.log('error-----', error)
        return error?.response?.data
    }
}

export const DeleteLeadAPI = async (id) => {
    try {
        const url = `${environment.base_url}${Leads?.DeleteLeads}${id}`
        const response = await axios.post(url, id);
        return response;
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}
export const DeleteMultipleLeadAPI = async (Rowid) => {
    try {
        const url = `${environment.base_url}${Leads?.DeleteMultipleLeads}`
        const response = await axios.post(url, Rowid);
        return response;
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}

export const AssignLeadsAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Leads.AssignLeads}`
        const response = await axios.post(url, data)
        return response
    } catch (error) {
        console.log('error========', error)
        return error
    }
}


export const EditProfileAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Profile.EditProfile}${id}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error', error)
        return error;
    }
}

export const ChangePasswordAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Profile.ChangePassword}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error', error)
        return error;
    }
}

export const ConfirmPasswordAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Profile.ConfirmPassword}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error', error)
        return error;
    }
}

export const ForgotPasswordAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Profile.ForgotPassword}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error', error)
        return error;
    }
}

export const AddGroupsAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Groups.AddGroup}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error========', error);
        return error;
    }
}

export const UpdateGroupsAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Groups.editGroupURL}${id}`
        const reponse = await axios.post(url, data)
        return reponse
    } catch (error) {
        console.log('error========', error)
    }
}

export const DeleteGroupsAPI = async (id) => {
    try {
        const url = `${environment.base_url}${Groups?.DeleteGroup}${id}`
        const response = await axios.post(url, id);
        return response;
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}

export const GetGroupsByCompanyAPI = async (data) => {
    const { companyId = "", p = "", records = "" } = data;
    try {
        const url = `${environment.base_url}${Groups.GroupsByComapny}companyId=${companyId}&page=${p}&limit=${records}`;
        const response = await axios.get(url)
        return response?.data
    } catch (error) {
        console.log('Error:', error)
        return error;
    }
}


export const GetLeadsByGroupsAPI = async (data) => {

    try {
        const { viewGroupsid = "", p = "", records = "" } = data
        const url = `${environment.base_url}${Groups.GetLeadsByGroups}${viewGroupsid}?page=${p}&limit=${records}`;
        const response = await axios.get(url)
        return response?.data
    } catch (error) {
        console.log('Error:', error)
        return error;
    }
}

export const AddCallLogsAPI = async (data) => {
    try {
        const url = `${environment.base_url}${CallLogs.AddCallLogs}`;
        const response = await axios.post(url, data)
        return response;
    } catch (error) {
        console.log('error========', error)
        return error;
    }
}

export const UpdateCallLogsAPI = async (data, id) => {
    try {
        const url = `${environment.base_url}${CallLogs.updateLeadCallLogById}${id}`;
        const response = await axios.post(url, data)
        return response;
    } catch (error) {
        console.log('error========', error)
        return error;
    }
}

export const LeadsForUsersAPI = async (data) => {
    const { id = "", role = "", companyId = "", p = "", records = "" } = data
    try {
        const url = `${environment.base_url}${LeadsForUsers.leadsForUser}id=${encodeURIComponent(id)}&role=${encodeURIComponent(role || '')}&companyId=${encodeURIComponent(companyId || '')}&search=&leadStatus=${encodeURIComponent(data.status || '')}&page=${p}&limit=${records}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.error("API Error:", error);
        return error;
    }
};

export const getLeadUserHistoryAPI = async (id) => {
    try {
        const url = `${environment.base_url}${LeadsHistory.leadsHistory}${id}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const getCallLogsAPI = async (data) => {
    const { leadId = "", p = "", records = "" } = data
    try {
        const url = `${environment.base_url}${GetCallLogs.getCallLogs}${leadId}?page=${p}&limit=${records}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const updateLeadAndCallLog = async (data) => {
    try {
        const url = `${environment.base_url}${CallLogs.updateLeadAndCallLog}`;
        const response = await axios.post(url,data);
        return response;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const getUserTalkTimeAPI = async (data) => {
    const { userId = "", startDate = "", endDate = "",p = "", records = "" } = data
    try {
        const url = `${environment.base_url}${GetCallLogs.getUserTalkTime}?userId=${userId}&startDate=${startDate}&endDate=${endDate}&page=${p}&limit=${records}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const AddLeadGroupsAPI = async (data) => {
    try {
        const url = `${environment.base_url}${LeadsGroups.leadsGroupsURL}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error========', error);
        return error;
    }
}

export const getLeadsCountAPI = async (data) => {
    const { id = "", role = "", startDate = "", endDate = "", company = "" } = data
    try {
        const url = `${environment.base_url}${GetLeadsCount.getLeadsCount}id=${id}&role=${role}&startDate=${startDate}&endDate=${endDate}&company=${company}`;
        const response = await axios.get(url);
        return response?.data;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const GetallDashboardLeadsAPI = async (data) => {
    const { company = "", dashboardStatus = "", role = "", id = "", startDate = "", endDate = "", p = "", records = "" } = data;
    try {
        const url = `${environment.base_url}${GetAllDashboardLeadsURL.getAllDashboardLeads}id=${id}&role=${role}&startDate=${startDate}&endDate=${endDate}&company=${company}&dashboardStatus=${dashboardStatus}&page=${p}&limit=${records}`;
        const response = await axios.get(url);
        return response.data;
    } catch (err) {
        console.log('Error:', err)
    }
}

export const teamLeadMappingAPI = async (data) => {
    try {
        const url = `${environment.base_url}${TeamLeadMappingURL.teamLeadMappingURL}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log("API Error:", error);
        return error;
    }
}

export const UserReportAPI = async (data) => {
    const { userId = "", company = "", startDate = "", endDate = "" } = data
    try {
        const url = `${environment.base_url}${EmployeeReport.UserReport}userId=${userId}&company=${company}&startDate=${startDate}&endDate=${endDate}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err?.response;
    }
}
export const TeamHeirachyAPI = async (userId) => {
    try {
        const url = `${environment.base_url}${EmployeeReport.TeamHeirachy}?userId=${userId}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}

export const GetAllMispunchAPI = async (data) => {
    const { userId = "", companyId="",p="",records = ""  } = data
    try {
        const url = `${environment.base_url}${Mispunch.getAllMispunch}?userId=${userId}&companyId=${companyId}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        return response?.data;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}

export const DeleteMispunchAPI = async (id) => {
    try {
        const url = `${environment.base_url}${Mispunch?.deleteMispunch}${id}`
        const response = await axios.post(url, id);
        return response;
    } catch (error) {
        console.log('error', error)
        return error?.response?.data
    }
}

export const AddMispunchAPI = async (data) => {
    try {
        const url = `${environment.base_url}${Mispunch.createMispunch}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error========', error);
        return error;
    }
}

export const UpdateMispunchAPI = async (id, data) => {
    try {
        const url = `${environment.base_url}${Mispunch.updateMispunch}${id}`
        const reponse = await axios.post(url, data)
        return reponse
    } catch (error) {
        console.log('error========', error)
    }
}

export const getAllTeamAttendence = async (data) => {
    const { userId = "", companyId="", startDate="",endDate="",user="", p="",records = ""  } = data
    try {
        const url = `${environment.base_url}${Attendence.getAllSubordinatesAttendence}?companyId=${companyId}&userId=${userId}&startDate=${startDate}&endDate=${endDate}&user=${user}&page=${p}&limit=${records}`
        const response = await axios.get(url, data)
        return response?.data;
    } catch (error) {
        console.log('error========', error)
    }
}

export const getAllOwnAttendence = async (data) => {
    const { userId = "", companyId="",p="",records = "",startDate="", endDate=""  } = data
    try {
        const url = `${environment.base_url}${Attendence.getALLOwnAttendence}?companyId=${companyId}&userId=${userId}&startDate=${startDate}&endDate=${endDate}&page=${p}&limit=${records}`
        const response = await axios.get(url, data)
        return response?.data;
    } catch (error) {
        console.log('error========', error)
    }
}
export const AddAttendenceAPI = async (data) => {
    try {
        const url = `${environment.base_url}${AttendenceURL.createAttendence}`;
        const response = await axios.post(url, data);
        return response;
    } catch (error) {
        console.log('error========', error);
        return error;
    }
}
export const updateAttendenceAPI = async (data) => {
    const { userId = "", companyId = "" } = data
    try {
        const url = `${environment.base_url}${AttendenceURL.updateAttendenceByUserId}?userId=${userId}&companyId=${companyId}`
        const response = await axios.post(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}
export const updateBreakByUserId = async (data) => {
    const { userId = "", companyId = "" } = data
    try {
        const url = `${environment.base_url}${AttendenceURL.updateBreakByUserId}?userId=${userId}&companyId=${companyId}`
        const response = await axios.post(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}
export const getAttendenceByUserIdAPI = async (userId) => {
    try {
        const url = `${environment.base_url}${AttendenceURL.getAttendenceByUserId}/${userId}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}

export const getSingleAttendence = async (userId) => {
    try {
        const url = `${environment.base_url}${AttendenceURL.getSingleAttendence}/${userId}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}

export const getLatestBreak = async (userId) => {
    try {
        const url = `${environment.base_url}${AttendenceURL.getLatestBreak}/${userId}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}


// Notification API
export const getAllNotificationAPI = async (data) => {
    const {  companyId="", userId = "", user="" } = data
    try {
        const url = `${environment.base_url}${notification.getAllNotification}?companyId=${companyId}&userId=${userId}&user=${user}`
        const response = await axios.get(url)
        return response;
    } catch (err) {
        console.log('Error:', err)
        return err?.response;
    }
}

export const GetUserStatusAPI = async (data) => {
    const { userId = "", companyId="", statusType= "", p="",records = ""  } = data
    try {
        const url = `${environment.base_url}${EmployeeReport.getUserStatus}?userId=${userId}&companyId=${companyId}&statusType=${statusType}&page=${p}&limit=${records}`
        const response = await axios.get(url)
        // console.log('response==--------', response.data)
        return response?.data;
    } catch (err) {
        console.log('Error:', err)
        return err;
    }
}